import React from 'react';
import { Route, Routes } from 'react-router-dom';
import OrganisationRolesOverview from '../components/OrganisationRolesOverview';

const OrganisationRolesScene = () => (
  <Routes>
    <Route
      path=":action?/:tag?"
      element={<OrganisationRolesOverview menuName="organisationRoles_plural" />}
    />
  </Routes>
);

export default OrganisationRolesScene;
